export enum OrderWordsTypes {
    GET_ORDER_WORDS = '@@/order-words/get_order_words',
    ADD_ORDER_WORDS = '@@/order-words/add_order_words',
    UPDATE_ORDER_WORDS = '@@/order-words/update_order_words',
    SELECT_ORDER_WORDS = '@@/order-words/select_order_words',
    RESET_ORDER_WORDS = '@@/order-words/reset_order_words',
    DELETE_ORDER_WORDS = '@@/order-words/delete_order_words',
}